import { chosenSites } from "app/common/services/chosenSites";
import { TrafficGrowthComparisonTemplateV2 } from "app/components/widget/dashboard/TrafficGrowthComparisonTemplate-v2";
import { TrafficEngagementComparePopSubtitleV2 } from "app/components/widget/widget-subtitle-templates/TrafficEngagementComparePopSubtitle-v2";
import { WidgetMessages } from "app/components/widget/widget-types/Widget";
import { CHART_COLORS } from "app/constants/ChartColors";
import DurationService from "app/services/DurationService";
import { fetchWebsitesFaviconsQuery } from "app/services/sitesService/queries/sitesQueries";

import { getTrafficEngagmentComparePopSubtitle } from "../widget-subtitle-templates/traffic-engagment-compare-pop";

import { BarChartWidget } from "./BarChartWidget";

export class TrafficGrowthComparisonWidget extends BarChartWidget {
    public isPptSupported = () => {
        return false;
    };

    public static getWidgetMetadataType() {
        return "TrafficGrowthComparison";
    }

    public static getWidgetResourceType() {
        return "Table";
    }

    public static getWidgetDashboardType() {
        return "BarChart";
    }

    constructor() {
        super();
    }

    public getViewData() {
        super.getViewData();
        const { forWidget } = DurationService.getDurationData(
            this._widgetConfig.properties.duration,
            this._widgetConfig.properties.comparedDuration,
            this._metricConfig.component,
        );
        this.viewData.customSubtitle = getTrafficEngagmentComparePopSubtitle(forWidget);
        this.viewData.customSubtitleComponent = TrafficEngagementComparePopSubtitleV2;
        this.viewData.duration = forWidget;
        this.viewData.chosenSites = chosenSites;
        this.viewData.isDashboard = this._swNavigator.isDashboard();

        this.emit(WidgetMessages.WIDGET_UPDATED, this.viewData);
        return this.viewData;
    }

    public callbackOnGetData(response: any) {
        if (!this._swNavigator.isDashboard()) {
            this.data = response.Data.map((item) => {
                return {
                    Domain: item.Domain,
                    color: chosenSites.getSiteColor(item.Domain),
                    ComparedPeriodVisits: item.ComparedPeriodVisits,
                    OriginalPeriodVisits: item.OriginalPeriodVisits,
                    Change: item.Change,
                    image: chosenSites.listInfo[item.Domain].icon,
                };
            });
            super.callbackOnGetData(response);
            this.setExcelUrl();
        } else {
            this.data = [];
            void fetchWebsitesFaviconsQuery(response.Data.map(({ Domain }) => Domain) as string[]).then((icons) => {
                this.data = response.Data.map((item, index) => {
                    return {
                        Domain: item.Domain,
                        color: CHART_COLORS.compareMainColors[index],
                        ComparedPeriodVisits: item.ComparedPeriodVisits,
                        OriginalPeriodVisits: item.OriginalPeriodVisits,
                        Change: item.Change,
                        image: icons[item.Domain],
                    };
                });
                super.callbackOnGetData(response);
                this.setExcelUrl();
            });
        }
    }

    protected _getExcelEndPoint() {
        const ctrl = this._widgetConfig.properties.apiController;
        const excelMetric = this._widgetConfig.properties.excelMetric;
        return `/widgetApi/${ctrl}/${excelMetric}/Excel?`;
    }

    protected validateData(data) {
        return data && !!data.length;
    }

    private setExcelUrl() {
        this["chartConfig"] = {
            ...this["chartConfig"],
            export: {
                title: this.getViewData().title,
                csvUrl: this.excelUrl,
            },
        };
    }

    get templateUrl() {
        return `/app/components/widget/widget-templates/traffic-change-compare.html`;
    }

    get templateComponent() {
        return TrafficGrowthComparisonTemplateV2;
    }
}

TrafficGrowthComparisonWidget.register();
